// import React, { useState } from "react";
// import InvoiceDetailsModal from "./InvoiceDetailsModal";
// import saleService from "../Services/saleService";

// const PharmacyInvoicesModal = ({ invoices, onClose }) => {
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchInvoiceDetails = async (id) => {
//     try {
//       setLoading(true);
//       const response = await saleService.fetchPharmacySalesById(id);
//       setSelectedInvoice(response.sale);
//     } catch (error) {
//       console.error("Error fetching invoice details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-PK", options);
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
//       <div className="bg-white p-4 rounded-lg shadow-lg w-2/3 relative ml-12 max-h-[80vh] overflow-y-auto">
//         <div className="grid grid-cols-3">
//           <p className="text-sm font-bold mb-4">{formatDate(invoices[0]?.created_at)}</p>
//           <h2 className="text-xl font-bold mb-4 text-center">Pharmacy Invoices</h2>
//         </div>

//         {/* Close Button */}
//         <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-red-500">
//           ✖
//         </button>

//         <table className="w-full border-collapse border border-gray-200">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="p-2 border">Date</th>
//               <th className="p-2 border">Time</th>
//               <th className="p-2 border">Customer Name</th>
//               <th className="p-2 border">Amount</th>
//               <th className="p-2 border">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoices.map((invoice, index) => {
//               const dateObj = new Date(invoice.created_at);
//               const formattedDate = dateObj.toLocaleDateString(undefined, {
//                 month: "short",
//                 day: "2-digit",
//                 year: "numeric",
//               });
//               const formattedTime = dateObj.toLocaleTimeString(undefined, {
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 hour12: true,
//               });

//               return (
//                 <tr key={index} className="text-center">
//                   <td className="p-2 border">{formattedDate}</td>
//                   <td className="p-2 border">{formattedTime}</td>
//                   <td className="p-2 border">{invoice.customer_name}</td>
//                   <td className="p-2 border font-bold">Rs.{invoice.amount}</td>
//                   <td className="p-2 border">
//                     <button
//                       onClick={() => fetchInvoiceDetails(invoice.id)}
//                       className="bg-[#4B5563] text-white px-3 py-1 rounded hover:bg-[#5b636d]"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>

//         {/* Invoice Details Modal */}
//         {selectedInvoice && <InvoiceDetailsModal invoice={selectedInvoice} onClose={() => setSelectedInvoice(null)} />}
//       </div>
//     </div>
//   );
// };

// export default PharmacyInvoicesModal;

import React, { useState } from "react";
import InvoiceDetailsModal from "./InvoiceDetailsModal";
import saleService from "../Services/saleService";

const PharmacyInvoicesModal = ({ invoices, onClose }) => {
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchInvoiceDetails = async (id) => {
    try {
      setLoading(true);
      const response = await saleService.fetchPharmacySalesById(id);
      setSelectedInvoice(response.sale);
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full
          max-w-full sm:max-w-[90%] md:max-w-[75%] lg:max-w-[65%]
          max-h-[95vh] sm:max-h-[94vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#215187] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Pharmacy Records
            </p>
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5 truncate">
              {invoices?.[0]?.created_at
                ? formatDate(invoices[0].created_at)
                : "Invoices"}
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* Info Strip */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#215187] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
            Rx
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800">
              Pharmacy Invoices
            </p>
            <p className="text-[11px] text-gray-400">
              {invoices.length} record(s) found
            </p>
          </div>
          <span className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap">
            Pharmacy
          </span>
        </div>

        {/* Table */}
        <div className="overflow-y-auto overflow-x-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          {invoices.length > 0 ? (
            <table className="w-full min-w-[480px] text-xs sm:text-sm border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  {["#", "Date", "Time", "Customer", "Amount", "Action"].map(
                    (h) => (
                      <th
                        key={h}
                        className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 px-3 py-2.5 text-left whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody>
                {invoices.map((invoice, index) => {
                  const dateObj = new Date(invoice.created_at);
                  return (
                    <tr
                      key={index}
                      className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-3 py-2.5 text-gray-400 font-medium">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                        {dateObj.toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                        {dateObj.toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-medium">
                        {invoice.customer_name}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-semibold whitespace-nowrap">
                        PKR {Number(invoice.amount).toLocaleString()}
                      </td>
                      <td className="px-3 py-2.5">
                        <button
                          onClick={() => fetchInvoiceDetails(invoice.id)}
                          disabled={loading}
                          className="text-[11px] font-semibold px-3 py-1.5 rounded-lg bg-[#2F6DB4] hover:bg-[#255A8C] text-white transition-colors whitespace-nowrap disabled:opacity-50"
                        >
                          {loading ? "..." : "View"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-10 text-gray-400 text-sm">
              No invoices available.
            </div>
          )}
        </div>
      </div>

      {selectedInvoice && (
        <InvoiceDetailsModal
          invoice={selectedInvoice}
          onClose={() => setSelectedInvoice(null)}
        />
      )}
    </div>
  );
};

export default PharmacyInvoicesModal;
